import SafeIcon from '../common/SafeIcon';
import './property-overview.css';

const highlights = [
  { icon: 'MapPin', value: '3.5 km', label: 'to Negombo centre' },
  { icon: 'Navigation', value: '15 km', label: 'to the airport' },
  { icon: 'Sun', value: 'Steps away', label: 'from Negombo Beach' }
];

const attractions = [
  {
    icon: 'Coffee',
    name: 'TukTuk Wine & Dine (500 meters away)',
    detail: 'Located just a short stroll down St. Joseph Street, this top-rated, vibrant multi-cuisine restaurant and live music venue offers fresh local lagoon seafood, artisanal pizza, and handcrafted cocktails.'
  },
  {
    icon: 'Sun',
    name: 'Negombo Beach (Steps away)',
    detail: 'Experience instant access to soft sands, gentle waves, and breathtaking sunset views over the Indian Ocean.'
  },
  {
    icon: 'Sunrise',
    name: 'Poruthota Beach (1.4 miles away)',
    detail: 'A lively coastal stretch known for its vibrant beach bars, cafes, and friendly local atmosphere.'
  },
  {
    icon: 'Home',
    name: "St. Mary's Church (Central Negombo)",
    detail: 'A stunning 20th-century neoclassical cathedral famous for its magnificent ceilings covered in vivid religious artwork.'
  },
  {
    icon: 'Compass',
    name: 'Negombo Dutch Fort',
    detail: "A historical 17th-century colonial landmark that offers a glimpse into the region's rich heritage."
  },
  {
    icon: 'Map',
    name: 'Angurukaramulla Temple',
    detail: 'A renowned Buddhist temple featuring an impressive dragon entrance and a massive reclining Buddha statue.'
  },
  {
    icon: 'Anchor',
    name: 'Hamilton Canal & Negombo Lagoon',
    detail: 'Perfect spots for peaceful boat rides, scenic views of local fishing life, and eco-adventures.'
  }
];

export default function PropertyOverview({ description }) {
  return (
    <div className="property-overview">
      <h2>Property Overview</h2>
      <p className="overview-intro">{description}</p>

      <div className="overview-highlights" aria-label="Location highlights">
        {highlights.map((highlight) => (
          <div className="overview-highlight" key={highlight.label}>
            <span className="overview-highlight-icon"><SafeIcon name={highlight.icon} /></span>
            <span className="overview-highlight-copy">
              <strong>{highlight.value}</strong>
              <small>{highlight.label}</small>
            </span>
          </div>
        ))}
      </div>

      <div className="overview-location">
        <span className="eyebrow">Well placed for your stay</span>
        <h3>Location Benefits &amp; Highlights</h3>
        <p>Choosing this location provides exceptional convenience, putting world-class dining, historical landmarks, and stunning natural attractions within immediate reach. Whether you are looking to kick off a Sri Lankan vacation with easy airport transit or want to dive straight into local culinary and cultural hotspots, this strategic spot makes exploring effortless.</p>
      </div>

      <div className="overview-attractions">
        <span className="eyebrow">Explore the neighbourhood</span>
        <h3>Key Benefits &amp; Nearby Attractions</h3>
        <ul className="property-attractions">
          {attractions.map(({ icon, name, detail }) => (
            <li key={name}>
              <span className="attraction-icon"><SafeIcon name={icon} /></span>
              <span className="attraction-copy"><strong>{name}</strong><span>{detail}</span></span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}